import { render } from "./CanvasInteractionHint.vue?vue&type=template&id=29d85283&ts=true"
import script from "./CanvasInteractionHint.vue?vue&type=script&lang=ts"
export * from "./CanvasInteractionHint.vue?vue&type=script&lang=ts"

import "./CanvasInteractionHint.vue?vue&type=style&index=0&id=29d85283&lang=scss"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__